import styled from 'styled-components';
import { breakpoints, colors } from '../../constants';
import { EditIcon } from '../../svg';

const EditButton = styled.div``;
const Title = styled.p``;
const EditTitle = styled.p``;

interface IProps {
    className?: string;
    title: string;
    answers: string | string[][];
    stepName: string;
    onEditButtonClick(stepName: string): void;
}

const BasePrevStep = ({
    className,
    title,
    answers,
    stepName,
    onEditButtonClick,
}: IProps) => {
    const multipleAnswers = Array.isArray(answers);

    return (
        <div className={className}>
            <span>
                <Title>{title}</Title>
                {multipleAnswers ? (
                    answers.map((answerArr, index) => {
                        const answerStr = answerArr.join(' ');

                        return <p key={index}>{answerStr}</p>;
                    })
                ) : (
                    <p>{answers}</p>
                )}
            </span>
            <EditButton onClick={() => onEditButtonClick(stepName)}>
                <EditTitle>WIJZIGEN</EditTitle>
                <EditIcon />
            </EditButton>
        </div>
    );
};

export const PrevStep = styled(BasePrevStep)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-left: ${`3px solid ${colors.greyContrast}`};
    margin-top: 16px;
    background-color: ${colors.offWhite};
    transition: background-color 0.2s;

    @media (${breakpoints.mediumMin}) {
        padding: 12px 32px;
    }

    :hover {
        background-color: ${colors.greyLighter};

        ${EditTitle} {
            color: ${colors.black};

            @media (${breakpoints.mediumMin}) {
                color: ${colors.greyDark};
            }
        }
    }

    ${Title} {
        color: ${colors.greyMedium};
        font-weight: 300;
    }

    p {
        color: ${colors.black};
    }

    ${EditButton} {
        display: flex;
        align-items: center;
        padding: 8px 0;
        margin-top: 3px;
        cursor: pointer;

        :hover {
            ${EditTitle} {
                color: ${colors.black};
            }

            ${EditIcon} {
                fill: ${colors.black};
            }
        }
    }

    ${EditTitle} {
        color: transparent;
        font-size: 12px;
        font-weight: 500;
    }

    ${EditIcon} {
        height: 15px;
        margin-left: 12px;
        margin-bottom: 5px;
        fill: ${colors.black};

        @media (${breakpoints.mediumMin}) {
            fill: ${colors.greyDark};
        }
    }

    ${EditTitle}, ${EditIcon} {
        transition: all 0.15s;
    }
`;
